import { Navigate } from "react-router";
import SpiderChart from "../components/spider_chart";
import CHARACTERS from "../characters";
import { AXIS_KEYS } from "../axes";
import t from "../locales";

export default function Result({ response }) {
  if (!response.getAnswer("groupCode")) return <Navigate replace to="/" />;

  return (
    <article className="card card--result">
      <title>{t("result.page-title")}</title>
      <div className="card__header">
        <h1 className="card__title">{t("result.title")}</h1>
        <p className="card__description">{t("result.description")}</p>
      </div>

      <div className="card__body">
        <SpiderChart
          layers={CHARACTERS.map(({ key, color }) => {
            const values = response.getAnswer(key);
            return {
              label: t(`characters.names.${key}`),
              color,
              values: AXIS_KEYS.map((axisKey) => values[axisKey] / 100),
            };
          })}
        />
      </div>
      <p className="card__description">{t("result.additionalInstructions")}</p>
    </article>
  );
}
